import en from "./en";
import sw from './sw';

const translations = {
  en,
  sw,
};
export const getTranslatedText = (key, locale) => {
  // const selectedLanguage = useSelector(
  //   state => state?.homePage?.selectedLanguage,
  // );
  // const state = selectedLanguage.val;
  // locale = ar;
  const currTranslation = translations[locale] ? translations[locale] : en;
  let translatedText = currTranslation[key]
    ? currTranslation[key]
    : en[key]
    ? en[key]
    : key;

  return translatedText;
};
